﻿
import angular from 'angular';

angular.module('folkeuni').factory('CartApi', function($http) {
  var self = this;
  var apiBase = '/api/cart/';

  self.add = function (cartObj) {
      return $http({
          method: 'post',
          data: cartObj,
          url: apiBase
      });
  };

  self.update = function(cartUpdateObj) {
    return $http({
      method: 'put',
      data: cartUpdateObj,
      url: apiBase
    });
  };

  self.voucherValidate = function (voucherObj) {
      return $http({
          method: 'post',
          data: voucherObj,
          url: apiBase + 'keyaccount'
      });
  };

  self.reset = function () {
    return $http({
      method: 'post',
      url: apiBase + 'empty'
    });
  };

  self.read = function() {
    return $http({
      method: 'get',
      url: apiBase
    });
  };

  self.validate = function (cartObj) {
      return $http({
          method: 'post',
          data: cartObj,
          url: apiBase + 'validate'
      });
  }

  self.checkout = function (cartObj) {
      return $http({
          method: 'post',
          data: cartObj,
          url: apiBase + 'checkout'
      });
  }

  self.voucherValidate = function (voucherObj) {
      return $http({
          method: 'post',
          data: voucherObj,
          url: apiBase + 'keyaccount'
      });
  }

  self.waitlistSubscribe = function(waitlistObj) {
    return $http({
      method: 'post',
      data: waitlistObj,
      url: apiBase + 'waitinglist'
    });
  };

  return self;
});
